export default __webpack_public_path__ + "static/Simplified_Laws_of_the_Game-b7292f704de9703e22d2c42a4b7e4ed6.svg";